module.exports = __webpack_public_path__ + "img/ap8pj-eqbxr.07fefa07.png";